import React, { FC } from "react";
import "../css/setting-list-tier.css";
import ToggleButton from "@core/uilibrary/dist/components/Button/ConceptualToggle/RoundCubeToggle/toggleButton";
import SettingInput from "../../../input-fs-cp/text-field-op/ts/setting-text-field";
import { SettingListProps } from "./setting-list-tier.type";

const SettingList: FC<SettingListProps> = ({
  groupId,
  mainTitle,
  paragraph,
  setList,
  isChecked,
  onToggle,
  getInputValue,
  onInputChange,
}) => {
  return (
    <section className="scl--sl-tier-const-sty-box">
      <div className="scl--sl-main-title-set">
        <h4>{mainTitle}</h4>
        <p>{paragraph}</p>
      </div>

      <div className="scl--sl-items-set-tier">
        {setList?.map((item) => (
          <div key={item.id} className="scl--sl-single-item-set-tier-box">
            <div className="scl--sl-single-set-tier-container">
              <h6>{item.title}</h6>
              <p>{item.description}</p>
            </div>

            <div className="scl--sl-single-item-set-btn-const">
              {(item.controlType === "input" || item.controlType === "both") && (
                <SettingInput
                  type={item.inputConfig?.type as "text" | "number"}  
                  width={item.inputConfig?.width ?? 120}
                  placeholderTxt={item.inputConfig?.placeholder}
                  value={getInputValue?.(groupId, item.id)}
                  onChange={(value) => onInputChange?.(groupId, item.id, value)}
                  validate={item.id === 4}
                  validateMode={item.id === 4 ?  /* istanbul ignore next */ "jobCode" : undefined}
                />
              )}
              {(item.controlType === "toggle" || item.controlType === "both") && (
                <ToggleButton
                  checked={isChecked(groupId, item.id)}
                  onChange={(checked) =>
                    onToggle({ groupId, groupTitle: mainTitle, itemId: item.id, itemTitle: item.title, checked })
                  }
                />
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default SettingList;